<template>
  <button
    :id="id"
    :class="button_class"
    :disabled="is_disabled"
    type="submit"
    class="px-4 py-2 flex items-center justify-center rounded-[30px] bg-black text-white border-b border-r border-white hover:shadow-lg hover:shadow-white/70 transition-shadow duration-500">
    
    <slot>
      <span v-if="!is_loading">{{ button_text }}</span>
      <LoadingDot v-else />
    </slot>
    
    </button>
</template>

<script>
import LoadingDot from '../molecules/LoadingDot.vue';

export default {
  name: 'SubmitButton',
  components: {
    LoadingDot
  },
  props: {
    id: String,
    button_class: String,
    button_text: String,
    is_disabled: Boolean,
    is_loading: Boolean
  }
}
</script>